<ng-container *transloco="let t">
  <form id="inputForm" *ngIf="inputForm$ | async as inputForm" [formGroup]="inputForm" (ngSubmit)="submit(inputForm)">
    <div class="row text-center justify-content-center mt-3">
      <div class="col-12 col-sm-8 col-md-6">
        <div class="row no-gutters">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label for="userId">{{t('explicit-user-enablings-session.fields.userId')}}</mat-label>
              <mat-select formControlName="userId">
                <mat-option *ngFor="let u of users$ | async" [value]="u.id">{{u.lastname}} {{u.firstname}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <ng-container *ngFor="let enabling of enablingsControls$ | async; index as i" formArrayName="enablings">
          <ng-container [formGroupName]="i">
            <div class="row mt-3 text-left">
              <div class="col-12">
                <mat-checkbox labelPosition="after" formControlName="enabled" #checkEnabled>
                  {{enabling.get('enablingId')?.value | enablingName | async}}</mat-checkbox>
              </div>
            </div>
            <div class="row mt-1" formGroupName="duration" *ngIf="checkEnabled.checked">
              <!-- years -->
              <div class="col-4 col-sm-3 col-md-2">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="years">{{t('common.years')}}</mat-label>
                  <input matInput formControlName="years" type="number" name="years" />
                </mat-form-field>
              </div>
              <!-- months -->
              <div class="col-4 col-sm-3 col-md-2">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="months">{{t('common.months')}}</mat-label>
                  <input matInput formControlName="months" type="number" name="months" />
                </mat-form-field>
              </div>
              <!-- days -->
              <div class="col-4 col-sm-3 col-md-2">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="days">{{t('common.days')}}</mat-label>
                  <input matInput formControlName="days" type="number" name="days" />
                </mat-form-field>
              </div>
              <!-- hours -->
              <div class="col-4 col-sm-3 col-md-2">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="hours">{{t('common.hours')}}</mat-label>
                  <input matInput formControlName="hours" type="number" name="hours" />
                </mat-form-field>
              </div>
              <!-- minutes -->
              <div class="col-4 col-sm-3 col-md-2">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="minutes">{{t('common.minutes')}}</mat-label>
                  <input matInput formControlName="minutes" type="number" name="minutes" />
                </mat-form-field>
              </div>
              <!-- seconds -->
              <div class="col-4 col-sm-3 col-md-2">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="seconds">{{t('common.seconds')}}</mat-label>
                  <input matInput formControlName="seconds" type="number" name="seconds" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label for="note">{{t('explicit-user-enablings-session.fields.note')}}</mat-label>
                  <textarea matInput formControlName="note"></textarea>
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </form>
</ng-container>
